import { supabase } from '@/lib/integrations/supabase'

export async function signIn(email: string, password: string) {
  return supabase.auth.signInWithPassword({ email, password })
}

export async function signUp(email: string, password: string, options?: any) {
  return supabase.auth.signUp({ email, password, options })
}

export async function getUser() {
  const { data } = await supabase.auth.getUser()
  return data?.user ?? null
}

export async function resetPasswordForEmail(email: string) {
  const redirectTo = `${window.location.origin}/reset-password`
  return supabase.auth.resetPasswordForEmail(email, { redirectTo })
}

export async function updatePassword(newPassword: string) {
  return supabase.auth.updateUser({ password: newPassword })
}

/**
 * Listen to authentication state changes
 * Returns unsubscribe function
 */
export function onAuthStateChange(callback: (event: string) => void): () => void {
  const { data } = supabase.auth.onAuthStateChange((event: string) => {
    callback(event)
  })
  const unsubscribe = data?.subscription?.unsubscribe ?? (() => {})
  return unsubscribe
}

/**
 * Get current authentication session
 */
export async function getAuthSession() {
  const { data } = await supabase.auth.getSession()
  return data?.session ?? null
}
